module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIgdmlld0JveD0iMCAwIDE2IDE2IiBmaWxsPSJub25lIj4KICA8cGF0aCBkPSJNNCA4LjAwMDk4SDEyIiBzdHJva2U9IiMwMDg5NDEiIHN0cm9rZS13aWR0aD0iMS42Ii8+Cjwvc3ZnPg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/minus-icon.svg
// module id = RaF0
// module chunks = 1